import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect, useContext } from 'react'
import { contains, indexOf, isEmpty } from 'underscore';
import { Context } from '../../..';
import DocumentsService from '../../../services/DocumentsService';

interface ItemProps {
    item: {
        id: number,
        nosology: string;
    },
    selected: [],
    setSelected: (value: any[]) => void
}

const Item = (props: ItemProps) => {
    const { item, selected, setSelected } = props;
    const { id, nosology } = item;
    const checked = contains(selected, id);

    const onChange = () => {
        const sel: any[] = selected.slice();
        if (contains(sel, id)) {
            sel.splice(indexOf(sel, id), 1)
        } else {
            sel.push(id);
        };
        setSelected(sel);
    };

    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={checked} id={`item${id}`} name="item" onChange={() => onChange()} />
            <label className="form-check-label" htmlFor={`item${id}`}>{nosology}</label>
        </div>
    );
};

interface Props {
    nosology: [],
    setNosology: (value: object) => void,
    cleanData: boolean,
    setCleanData: (value: boolean) => void,
};

export const RecsNosologyModal: FC<Props> = ({nosology, setNosology, cleanData, setCleanData }) => {
    const { store } = useContext(Context);
    const [nosologies, setNosologies] = useState<[]>([]);
    const [popov, setPopov] = useState<boolean>(false);
    const [title, setTitle] = useState<string[]>([]);
    const [selected, setSelected] = useState<any>([]);

    const getNosologies = async () => {
        const res = await DocumentsService.getNosologies();
        setNosologies(res.data.results);
    };

    useEffect(() => {
        getNosologies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (nosology.length) {
            setSelected(nosology)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nosology]);

    useEffect(() => {
        setSelected([]);
        setCleanData(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanData]);

    useEffect(() => {
        if (!isEmpty(nosologies)) {
            setTitle([]);
            // eslint-disable-next-line array-callback-return
            nosologies.map(item => {
                // eslint-disable-next-line array-callback-return
                selected.map((id: any) => {
                    if (item['id'] === id) {
                        setTitle(title => [...title, item['nosology']]);
                    }
                });
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    const getItems = () => {
        if (!isEmpty(nosologies)) {
            return nosologies.map(item => <Item key={item['id']} {...{ item, selected, setSelected }} />);
        } else {
            return <span><Trans>Nothing found</Trans></span>
        }
    };

    const openPopov = (e: React.ChangeEvent<any>) => {
        setPopov(true);
        e.target.value = ''
    };

    const closePopov = () => {
        setPopov(false);
        setNosology(selected)
    };



    return (
        <div className="form-group" style={{ position: "relative" }}>
            <div className="input-group">
                <div className="input-group-control w-100">

                    <input type="text" className="form-control"
                        placeholder={store.lang === 'ba' ? 'Тәҡдим нозологияларын һайлағыҙ' : store.lang === 'ru' ? 'Выберите нозологии рекомендаций' : 'Choose recommendations nosologies'}
                        value={title.join(', ')}
                        title={title.join(', ')}
                        readOnly
                        autoComplete="off"
                        onClick={(e: React.ChangeEvent<any>) => openPopov(e)}
                        onChange={() => { }} />
                </div>
            </div>
            {popov ?
                <div className="form-group popov">
                    <div className="popov__title d-flex justify-content-end">
                        <div>
                            <input type='button' className='btn text-primary' value={store.lang === 'ba' ? 'Ябырға' : store.lang === 'ru' ? 'Закрыть' : 'Close'} onClick={() => { closePopov() }} />
                        </div>
                    </div>
                    <div className="form-group">
                        {getItems()}
                    </div>
                </div>
                : null}
        </div>
    );
};